module.exports = __webpack_public_path__ + "img/thumb_2018-02.35d4b8d0.jpg";